// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const UpgradeIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Upgrade",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2m7.9 13.27c-.43.59-1.24.72-1.83.29a1.3 1.3 0 0 1-.29-.29L17.47 11v13.37c0 1.07-.29 1.5-1.5 1.5s-1.5-.26-1.5-1.5V11l-4.31 4.31a1.338 1.338 0 0 1-2.12 0c-.59-.38-.76-1.16-.38-1.74.1-.15.23-.28.38-.38l6.87-6.87c.58-.59 1.52-.59 2.11-.01l.01.01 6.87 6.87c.58.43.7 1.24.27 1.81q-.12.15-.27.27"
    })
  });
};